var map = {
	"./bg-default.png": 72901,
	"./bg-not-vip.png": 33367,
	"./bg-video.png": 91025,
	"./bg-vip.png": 85500,
	"./bg_pic_v.png": 80171,
	"./bg_pic_v@2x.png": 85724,
	"./btn-recharge.png": 19716,
	"./default-avatar.png": 14519,
	"./download-apple.png": 97161,
	"./download-google.png": 9042,
	"./download-title.png": 56547,
	"./google-play.png": 21317,
	"./icon-active.png": 29359,
	"./icon-agree-active.png": 82127,
	"./icon-agree-default.png": 83701,
	"./icon-arrow-left.png": 39714,
	"./icon-arrow-right.png": 47765,
	"./icon-close.png": 99536,
	"./icon-close2.png": 99898,
	"./icon-controls.png": 93971,
	"./icon-delete.png": 40080,
	"./icon-end.png": 20422,
	"./icon-facebook.png": 57023,
	"./icon-fast.png": 34351,
	"./icon-feedback.png": 59434,
	"./icon-fullscreen.png": 7815,
	"./icon-gem.png": 62360,
	"./icon-gems.png": 57093,
	"./icon-gold.png": 48203,
	"./icon-google.png": 81537,
	"./icon-googleplay.png": 44275,
	"./icon-gq.png": 10172,
	"./icon-ios.png": 17688,
	"./icon-logo.png": 19312,
	"./icon-more-golds.png": 5633,
	"./icon-position.png": 91710,
	"./icon-qrcode.png": 45038,
	"./icon-reboot.png": 51911,
	"./icon-recharge.png": 58905,
	"./icon-search.png": 90146,
	"./icon-sharer.png": 89359,
	"./icon-signout.png": 10064,
	"./icon-slow.png": 98516,
	"./icon-time.png": 99808,
	"./icon-tips.png": 40645,
	"./icon-toTop.png": 56159,
	"./icon-user-fast.png": 66345,
	"./icon-user-normal.png": 44427,
	"./icon-user-vip.png": 55972,
	"./icon-vip.png": 45159,
	"./img-badge-fast.png": 79064,
	"./img-badge-normal.png": 22435,
	"./img-badge.png": 36390,
	"./img-chikii.png": 34992,
	"./img-float-queue.png": 46532,
	"./img-notvip-chikii.png": 16095,
	"./img-post.png": 18587,
	"./img-vip-chikii.png": 53198,
	"./label-discount.png": 19706,
	"./label-gametime-bg.png": 63561,
	"./login-bg.png": 87878,
	"./logo.png": 15080,
	"./pic-notvip-tag.png": 68495,
	"./pic-vip-tag.png": 84231,
	"./pic_v@2x.png": 16424,
	"./play.png": 76432,
	"./qrcode-Appstore.png": 5611,
	"./qrcode-GooglePlay.png": 38900,
	"./recharge-success.png": 96813,
	"./vip-dialog.png": 49402,
	"./vip-panel.png": 10934,
	"./vip@2x.png": 24410
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64548;